import { render, staticRenderFns } from "./DealerDetail.vue?vue&type=template&id=1754e584&scoped=true"
import script from "./DealerDetail.vue?vue&type=script&lang=js"
export * from "./DealerDetail.vue?vue&type=script&lang=js"
import style0 from "./DealerDetail.vue?vue&type=style&index=0&id=1754e584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754e584",
  null
  
)

export default component.exports